import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Tippy from '@tippyjs/react';
import * as browser from '../../utils/browser';

const propTypes = {
  player: PropTypes.object,
  actions: PropTypes.object,
  chapters: PropTypes.array
};

export default class Chapters extends Component {
  getPercent(time) {
    const { player: { hasDVR, duration, mediaDuration } } = this.props;
    return time / (hasDVR ? mediaDuration : duration) * 100;
  }

  setChapter(chapter) {
    const { actions: { seek }, sendPlayerEvent } = this.props;
    seek(chapter.time);
    if (sendPlayerEvent) {
      sendPlayerEvent('Chapters', 'Click on Player Chapters', chapter.title);
    }
  }

  render() {
    if (browser.IS_MOBILE) return null;

    const { chapters } = this.props;
    return !!chapters && <div className="chapter-list">
      {chapters.map((item, key) => item && item.time && <Tippy
          animation="shift-away"
          appendTo="parent"
          zIndex={1000}
          offset={[0, 5]}
          content={item.title}>
            <div
              key={key}
              className="chapter-item"
              style={{
                left: `${this.getPercent(item.time)}%`
              }}
              onClick={() => this.setChapter(item)}>
            </div>
          </Tippy>
      )}
    </div>;
  }
}
